<div class="modal-body text-center">
  <p [innerHTML]="text"></p>
  <button type="button" class="btn btn-primary" (click)="confirm()">{{ "bulletins.table.checkBulletinsDialog.accept" | translate }}</button>
</div>
